import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import {
	notificationError,
	notificationSuccess,
	notificationWarning,
} from '../../../../../../components/Notifications/callNotifcation';
import {
	templateTagGroupActions,
	templateTagGroupApi,
	privateTemplateTagGroupSlice,
} from '../../../../../../entities/template/private-template-tag-group';
import { privateTemplateTagAPI } from '../../../../../../entities/template/private-template-tag';

export const useCreateTemplateTagGroup = () => {
	const dispatch = useAppDispatch();

	const [createPrivateTemplateTagGroup, requestData] = templateTagGroupApi.useCreateMutation();
	const { data: existingGroups } = templateTagGroupApi.useGetTemplateGroupsQuery({ limit: 127, page: 1 });

	const name = useSelector(privateTemplateTagGroupSlice.selectors.getCreateGroupName);
	const tags = useSelector(privateTemplateTagGroupSlice.selectors.getCreatedGroupTags);

	const onCreate = async () => {
		try {
			if (name) {
				const groupNames = existingGroups?.groupTags?.map((group) => group.name.toLowerCase()) ?? [];
				if (groupNames.length > 0 && groupNames.includes(name.toLowerCase())) {
					notificationWarning('Создание группы', `Группа с именем "${name}" уже существует`);
					return;
				}

				await createPrivateTemplateTagGroup({ tags, name }).unwrap();

				dispatch(templateTagGroupActions.setIsCreateGroupModalActive(false));
				dispatch(templateTagGroupActions.setCreateGroupName(''));
				dispatch(templateTagGroupActions.setCreatedGroupTags([]));

				dispatch(templateTagGroupApi.util?.invalidateTags(['templateTagGroup']));
				dispatch(privateTemplateTagAPI.util?.invalidateTags(['template_tags']));

				notificationSuccess('Группа успешно создана');
			}
		} catch (e) {
			notificationError('Произошла ошибка', 'Не удалось создать группу тегов');
		}
	};

	return {
		onCreate,
		requestData,
	};
};
